import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import * as React from "react";

// Simple SVG radial gauge ring: value 0-100
export default function GaugeRing({ title, value = 0, color = "#2e7d32" }) {
  const theme = useTheme();
  const radius = 100;
  const stroke = 20;
  const normalizedRadius = radius - stroke / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const clamped = Math.max(0, Math.min(100, value));
  const strokeDashoffset = circumference - (clamped / 100) * circumference;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mt: 1,
      }}
    >
      <svg height={300} width={300}>
        <circle
          stroke="#e0e0e0"
          fill="transparent"
          strokeWidth={stroke}
          r={normalizedRadius}
          cx={150}
          cy={150}
        />
        <circle
          stroke={color}
          fill="transparent"
          strokeLinecap="round"
          strokeWidth={stroke}
          strokeDasharray={`${circumference} ${circumference}`}
          style={{
            strokeDashoffset,
            transition: "stroke-dashoffset 0.6s ease",
          }}
          r={normalizedRadius}
          cx={150}
          cy={150}
        />
        <text
          x="150"
          y="156"
          textAnchor="middle"
          fontSize="22"
          fontWeight="600"
          fill={theme.palette.text.primary}
        >
          {clamped}%
        </text>
      </svg>
    </Box>
  );
}
